import { garantiaLimite } from "../constantes/paquetes";
const direccion =
  "Dirección: Av. Córdoba 111 Piso 31, CABA <br/> Teléfono: 0800-333-0303<br/>  CUIT: 30-50000319-3";

const footer_text =
  `Los depósitos en pesos y en moneda extranjera cuentan con la garantía de hasta $ ${garantiaLimite}. En las operaciones a nombre de dos o más personas, la garantía se prorrateará entre sus titulares. En ningún caso, el total de la garantía por persona y por depósito podrá exceder de $ ${garantiaLimite}, cualquiera sea el número de cuentas y/o depósitos. Ley 24.485, Decreto N° 540/95 y modificatorios y Com. "A" 2337 y sus modificatorias y complementarias. Se encuentran excluidos los captados a tasas superiores a la de referencia conforme a los límites establecidos por el Banco Central, los adquiridos por endoso y los efectuados por personas vinculadas a la entidad financiera.`;

const footer = direccion + "<br/><br/>" + footer_text;
/**
 * Configuración de circuito Cliente
 * Este objeto se mergea con el de campaña y este con ofertaDigital
 * En lo posible solo incluir configuraciones que cambian para cliente
 */
export default {
  cantPasos: 6,
  pasos: {
    simulacion: {
      component: "views/SimulacionCliente",
    },
    cliente: {
      path: "/cliente",
      component: "views/Cliente",
      titulo: "Continuá tu Plazo Fijo desde Banca Online",
      subtitulo: "¡Es fácil y rápido!",
      logoCobranding: false,
      pasoSiguiente: "",
      paso: 3,
      footerText: footer,
    },
  },
};
